<template>
  <a
    href="#"
    class="social-btn pass-btn"
    :style="loginButtonStyles"
    @click.prevent="showPasscodeFields()"
  >
    <i v-show="baseData.flags.loginBtnIcons" class="fa fa-lock" />
    <span v-text="$t('stripe')" />
  </a>
</template>

<script>
  import { logUserAction } from '../../utils/logging'
  export default {
    name: 'StripeLogin',
    props: ['api', 'action', 'wftkn'],
    computed: {
      baseData() {
        return this.$store.state.baseData
      },
      loginButtonStyles() {
        return {
          background: this.loginButtonColor || '#636363',
          color: this.loginButtonTextColor || '#ffffff',
          'justify-content':
            this.baseData.layouts.appLayout === 'app'
              ? 'center'
              : this.loginButtontextAlignment || 'flex-start',
        }
      },
      loginButtontextAlignment() {
        return this.baseData.fonts.alignments.loginBtns
      },
      loginButtonColor() {
        return this.baseData.colors.loginBtns.creditcardBtn
      },
      loginButtonTextColor() {
        return this.baseData.colors.loginBtns.loginBtnText
      },
    },
    methods: {
      showPasscodeFields() {
        logUserAction({ type: 'user_action', label: 'User Clicked Stripe Login Button' })
        this.$emit('showPaymentOptions')
      },
    },
  }
</script>

<style>
  .pass-btn {
    background: #636363;
  }
  .pass-btn:hover {
    background: #636363;
  }
</style>
